var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrisma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "acf1d295-1c1d-48fe-a262-863b23c509db"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "cd8c8655-16f2-4fb9-bdbc-81bdc4b1d1b7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(26.2 0 0 26.2 540 540)",
    id: "3050ea8f-ad75-45be-9950-450d36f003b7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-16.56, -20)",
    d: "M 32.908 30.475 L 19.151 1.26 C 18.802758424544507 0.527515840688906 18.08096815161677 0.04491457841754065 17.271 0.0029999999999998916 C 16.459167932725137 -0.05139418282827527 15.684455669816087 0.3502228211275603 15.261000000000001 1.045 L 0.34 25.212 C -0.12321536346867173 25.956982255133873 -0.11346948981536598 26.90272183445067 0.3650000000000004 27.637999999999998 L 7.66 38.935 C 8.226804055955139 39.805916881780476 9.298995660057752 40.20020669748273 10.295000000000002 39.904 L 31.465000000000003 33.642 C 32.109923728143954 33.45344177079567 32.64142084842466 32.99453759968164 32.922000000000004 32.384 C 33.19876672345128 31.776402701591064 33.19401165678444 31.077773675925656 32.909000000000006 30.474 z M 29.828000000000003 31.728 L 11.864 37.04 C 11.316 37.202999999999996 10.790000000000001 36.728 10.904 36.175 L 17.322 5.4439999999999955 C 17.442 4.868999999999995 18.236 4.777999999999995 18.487 5.309999999999995 L 30.368 30.539999999999996 C 30.47430909676314 30.76753294535903 30.475591114002714 31.030219962571046 30.371507931166008 31.258779706027614 C 30.267424748329304 31.487339449484185 30.06842752694589 31.658821863922597 29.826999999999998 31.727999999999994 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrisma);
export default __webpack_public_path__ + "static/media/prisma.8c57446965652b591231b189a0b4e4c7.svg";
export { ForwardRef as ReactComponent };